import { isRebuildCalculatorEnabled, isContentsCalculatorEnabled } from 'ctm-components/components/feature_flags_utils';
import { homecontentsBrandcodes } from '../../constants';

export const footerDisclaimer = ({ comparisonUrl, fsgUrl, experimentId, coverType, hasGnafId, serverConfig }) => {
    // Detect current page from the browser's location
    const isCoverDetailsPage = typeof window !== 'undefined' && window.location.pathname === '/home-contents-insurance/journey/cover_details';
    const rebuildCalculatorDisclaimer = `<p>The rebuild estimate is provided by Finity Consulting Pty Limited (Finity)
            and should be used as a guide only and does not constitute personal advice. The estimate may not
            take into account all features of your property or your personal objectives, financial situation
            or needs. Please check with a valuer or other suitably qualified professional for an accurate
            estimate. Neither Compare the Market nor Finity accept any responsibility or liability for the
            accuracy of the estimate, or for any reliance on or use of the estimate as the basis of any
            decision.</p>`;
    const contentsCalculatorDisclaimer = `<p>Typical replacement costs are provided by Sum Insured. Whilst every care
            is taken to ensure the accuracy of the information as a guide for costing, no responsibility is
            accepted by Sum Insured for its accuracy. Please check with a valuer or other suitably qualified
            professional for an accurate estimate. Compare the Market takes no responsibility for the costs
            provided by Sum Insured nor any liability for the accuracy of or reliance upon or use of, the
            costs. Sum Insured is a trading name of Land Services SA Operating Pty Ltd (ACN 618 229 815)
            as trustee for Land Services SA Operating Trust (ABN 86 836 650 939). Figure rounded to nearest
            $100.</p>`;
    const homeContentsDisclaimer = `<p>We do not compare all home insurers or products in the market.
          Any advice given above is general and does not take into account your objectives, financial situation or needs.
          You should consider whether the advice is suitable for you and your personal circumstances,
          and before you make any decision about whether to purchase a product, you should read the PDS for that product.
          A number of the home and contents insurance brands on our panel are arranged by Auto &amp; General Services Pty Ltd ACN 003 617 909
          on behalf of the insurer Auto &amp; General Insurance Company Limited ACN 111 586 353,
          both of which are related entities of Compare the Market Pty Ltd.
          Our relationship with those companies does not impact the integrity of our comparison service,
          and we continue to work hard to encourage brands that do not currently participate on our comparison service to come on board.</p>`;
    let additionalRebuildDisclaimer = '';
    let additionalContentsDisclaimer = '';
    if (isCoverDetailsPage && isRebuildCalculatorEnabled(serverConfig) && coverType !== 'C' && hasGnafId) {
        additionalRebuildDisclaimer = rebuildCalculatorDisclaimer;
    }
    if (isCoverDetailsPage && isContentsCalculatorEnabled(serverConfig) && coverType !== 'H') {
        additionalContentsDisclaimer = contentsCalculatorDisclaimer;
    }
    return `${additionalRebuildDisclaimer}
        ${additionalContentsDisclaimer}
        <p>We recommend you read the Product Disclosure Statement (PDS) before you make a decision.</p>
        <p>Please note that when we display quotes on our comparison results page,
         they are indicative and subject to change based on further questions by the insurer.</p>
         ${homeContentsDisclaimer}
          <p>For more information about the range of insurers and products we compare, how our service works,
          and how we make our money (remembering that the service is free for you to use),
          read our <a href="${comparisonUrl}" target="_blank">how our comparison works</a> page,
          and read our <a href="${fsgUrl}" target="_blank">Financial Services Guide (General Insurance Products)</a>.</p>
          <p>The Compare The Market website and trading name are owned by Compare The Market Pty Ltd ACN 117 323 378 AFSL 422926.</p>`;
};

export const trustedPartnerContent = () => {
    const trustedPartnerConfig = {
        title: 'Trusted Partners',
        description: 'Our Trusted Partners, for the purpose of your invitation to call, are:',
        reasons: [
            'the insurer that ranks in position 1 on our results page;',
            'any other insurer with whom you express an interest to contact, by commencing an online application or call enquiry; or',
            'if we are unable to provide you with any quotes, a specialised broker - Shielded Insurance Brokers.'
        ],
        disclaimer: ''
    };
    return trustedPartnerConfig;
};

export const redbookDisclosureContent = () => {
    const redbookDisclosureConfig = {
        title: '',
        description: ''
    };
    return redbookDisclosureConfig;
};

export const partnerBrands = () => [
    homecontentsBrandcodes.BUDD,
    homecontentsBrandcodes.WOOL,
    homecontentsBrandcodes.HUDD,
    //homecontentsBrandcodes.HONY,
    //homecontentsBrandcodes.HBOQ,
    homecontentsBrandcodes.EXIG,
    homecontentsBrandcodes.EXCL,
    homecontentsBrandcodes.AHM
    // todo: Uncomment for BUPA go-live
    // homecontentsBrandcodes.BUPA
    // homecontentsBrandcodes.VIRG
];

export const crossSellOtherVerticalsOnResults = () => true;
export const spinnerColour = () => '#1c3e94';
export const showNoResultsOverlayGenericMessage = () => false;
export const resultsScreenDefaultDisplayMode = () => 'row';

export const contactDetailOptInPrivacyMessage = ({ companyName, fsgUrl, privacyPolicyUrl }) => {
    return `I have read and accept ${companyName}'s
        <a href="${privacyPolicyUrl}" target="_blank" data-id="websitePrivacyPolicyFormTermsLink" rel="noopener noreferrer">Privacy Collection Notice</a> and
        <a href="${fsgUrl}" target="_blank" data-id="websiteFinancialServicesGuideLink" rel="noopener noreferrer">Financial Services Guide</a>,
        including that ${companyName} may email and SMS me about the services it provides. By providing a contact number, I invite ${companyName} or its
        <a id="trustedPartnersOpen" data-id="trustedPartnersOpen">Trusted Partners</a> to call me during the call centre
        <a id="callCentreHoursOpen" data-id="callCentreHoursOpen">opening hours</a>
        to discuss the potential purchase of a home and contents insurance policy.`;
};

export const enableResultsFeatureAccordion = () => false;
export const showPriceConfidenceBanner = (experimentId, urlOne, urlTwo, urlThree) => experimentId === 'expPriceConfidenceBanner' && !!urlOne && !!urlTwo && !!urlThree;
export const spinnerType = () => 'CircularProgress';
